module.exports = __webpack_public_path__ + "bedd77b8e56e2dcc8e3c93792d15cd33.pdf";